// cieloService.js
const API_ENDPOINT = '/.netlify/functions/api';

async function handleApiResponse(response) {
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    throw new Error('Invalid response format from server');
  }

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }

  if (data.error) {
    throw new Error(data.error);
  }

  return data;
}

export async function fetchWalletStats(walletAddress) {
  try {
    console.log('Fetching wallet stats for:', walletAddress);
    const response = await fetch(`${API_ENDPOINT}/${walletAddress}/pnl-total-stats`);
    const data = await handleApiResponse(response);
    console.log('Received wallet stats:', data);

    return {
      combinedPnl: data.data?.combined_pnl_usd || 0,
      realizedPnl: data.data?.realized_pnl_usd || 0,
      unrealizedPnl: data.data?.unrealized_pnl_usd || 0,
      winRate: data.data?.winrate || 0,
      averageHoldingTime: data.data?.average_holding_time || 0,
      tokensTraded: data.data?.tokens_traded || 0
    };
  } catch (error) {
    console.error('Failed to fetch wallet stats:', error);
    throw error;
  }
}

export async function fetchPortfolioValue(walletAddress) {
  try {
    console.log('Fetching portfolio value for:', walletAddress);
    const response = await fetch(`${API_ENDPOINT}/${walletAddress}/portfolio-value`);
    const data = await handleApiResponse(response);
    console.log('Received portfolio value:', data);

    return {
      current: data.data?.current_value || 0,
      change24h: data.data?.change_24h || 0,
      changePercent24h: data.data?.change_percent_24h || 0,
      tokens: data.data?.tokens || []
    };
  } catch (error) {
    console.error('Failed to fetch portfolio value:', error);
    throw error;
  }
}

export async function fetchTransactions(walletAddress) {
  try {
    console.log('Fetching transactions for:', walletAddress);
    const response = await fetch(`${API_ENDPOINT}/${walletAddress}/transactions`);
    const data = await handleApiResponse(response);
    console.log('Received transactions:', data);

    return data.data?.transactions || [];
  } catch (error) {
    console.error('Failed to fetch transactions:', error);
    throw error;
  }
}